export default __webpack_public_path__ + "static/media/logo1.00d25474.png";